<template>
  <div v-if="rows!==null" class="wtOuter">
    <div class="wtHeader row">
      <div class="col-10 tabletitle">
        <span id="tableTitle">{{title}}</span> <span v-if="rows!==null&&rows.length>0">(<span v-if="pageCount===null">{{recordcount}}</span><span v-if="pageCount!==null">{{startPageSpan}}-{{endPageSpan}} <span id="of">of</span> {{totalRecords}}</span> <span id="table_records">Records</span>)</span>
        <span class="ib ml-1" v-for="burger in burgerMenu" v-if="burgerMenu.length>0">
          <span v-if="burger.length>1">
            <b-form-select class="burger ib" v-model="burgerselect" @change="doBurgerChange" :options="burger"></b-form-select>
          </span>
          <span v-if="burger.length===1">
            <button class="btn btn-secondary smallheight nopadding" @click="doBurgerClick(burger[0].value)">{{burger[0].html}}</button>
          </span>
        </span>

      </div>
      <div class="col-2 text-right">
        <span>
          <a role="button" href="javascript:void(0)" @click="doPrev" v-show="pageCount!==null&&pageselected>1">&lt;-Prev</a>&nbsp;
          <a role="button" href="javascript:void(0)" @click="doNext" v-show="pageCount!==null&&pageselected!=pageCount">Next-&gt;</a>&nbsp;
          <button class="btn-transparent" @click="showUniversalSearch()" v-show="pageCount!==null&&noFreeFilter!=='true'">
            <font-awesome-icon icon="search" aria-label="Search Entire Table"></font-awesome-icon>
          </button>
          <button class="btn-transparent tablesettings" @click="doTableSettings()">
            <font-awesome-icon icon="cog" size="lg" aria-label="Change Table Settings"></font-awesome-icon>
          </button>
        </span>
      </div>
    </div>
    <div>
      <table class="table">
        <thead v-draggable="cols">
          <template v-for="c in cols">
        <th :class="{draggable: c.canMove}">
          <div class="wtColumnHeader">
            <div class="row">
              <div class="col-10 wtColumnName">
                <button class="btn-transparent-white" @click="doSort(c.id)">
                  <span v-if="colsort!==null && c.id===colsort.id">
                    <font-awesome-icon aria-label="Sort bottom to top" icon="caret-down" v-if="colsort.direction===0"></font-awesome-icon>
                    <font-awesome-icon aria-label="Sort top to bottom" icon="caret-up" v-if="colsort.direction===1"></font-awesome-icon>
                    &nbsp;
                  </span>
                  {{c.name}}
                </button>
              </div>
              <div class="col-2 text-right toolbuttons">
                <button class="btn-transparent-white mr-1" @click="openFilter(c.id)" v-if="c.isfilterable===true">
                  <font-awesome-icon icon="filter" aria-label="Filter"></font-awesome-icon>
                </button>
                <span class="fakeHeight" v-if="c.isfilterable!==true">
                  .
                </span>
              </div>
            </div>
            <div class="popoutFilter" v-if="c.isopen===true">
              <input class="fullWidth" v-model="c.filtertext" v-on:input="doFilter(c.id)" />
            </div>
          </div>
        </th>
</template>
        </thead>
<tbody>
  <template v-for="row in rows">
    <tr v-bind:class="{isOdd: row.isOdd}">
      <template v-for="(col, index) in cols">
        <td v-bind:class="{'text-center': col.position==='center', 'text-left': col.position==='left', 'text-right': col.position==='right'}">
          <div v-bind:class="{'wtColumn':true, 'isLast':col.islast===true}">
            <div v-if="col.iscalculated">
              <div v-if="col.islink===true">
                <a @click="doMethod(col.method,row[col.id],col.ref)" href="javascript:void(0)" v-html="row['oid']"></a>
              </div>
              <div v-if="col.islink!==true">
                <button @click="doMethod(col.method,row[col.id],col.ref)" class="btn-transparent"><font-awesome-icon v-bind:icon="col.icon" v-bind:aria-label="col.name" size="lg"></font-awesome-icon></button>
              </div>
            </div>
            <div v-if="!col.iscalculated" v-html="row[col.id]">
            </div>
          </div>
        </td>
      </template>
    </tr>
  </template>
</tbody>
      </table>
<div class="wtTopBorder row" v-show="rows!==null&&rows.length>0">
  <div class="col-lg-9">
    <div v-if="pageCount!==null">
      <span id="page">Page</span>: <select v-model="pageselected" @change="doPageSelection"><option v-for="index in pageCount" :key="index" :value="index">{{index}}</option></select>&nbsp;
      <a role="button" href="javascript:void(0)" @click="doPrev" v-show="pageselected>1">&lt;-Prev</a>&nbsp;
      <a role="button" href="javascript:void(0)" @click="doNext" v-show="pageselected!=pageCount">Next-&gt;</a>&nbsp;
      <a role="button" href="javascript:void(0)" @click="doShowAll">Show All</a>
    </div>
  </div>
  <div class="col-lg-3 text-right">
    <span v-if="hasExportExcel==='1'" class="buttonExport">
      <button class="btn-transparent" @click="doExcelExport()">
        <img src="@/assets/images/Excel-2-icon.png" aria-label="Export to Excel" title="Export to Excel" id="export_to_excel" />
      </button>
    </span>
    <!--This option is disabled on July 2024-->
    <!--<span v-if="hasExportPDF==='1'" class="buttonExport">
      <button class="btn-transparent" @click="doPDFExport()">
        <img src="@/assets/images/PDF-icon.png" alt="Export to PDF" aria-label="Export to PDF" title="Export to PDF" />
      </button>
    </span>-->
  </div>
</div>
    </div>

<div v-if="rows!==null&&rows.length===0" class="mt-2">
  {{noRecords}}
</div>
<div v-if="rows===null">
  Data is Loading...
</div>
<div class="universalSearchBox" v-show="universalSearchVisible===true">
  <div class="row">
    <div class="col-12">
      Search All Records:<br />
      <input v-model="universalSearchText" style="height:30px;width:100%" />
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-6">
      <button class="btn btn-danger btn-sm" @click="cancelUniversalSearch()">Cancel</button>
    </div>
    <div class="col-6 text-right">
      <button class="btn btn-primary btn-sm" @click="doUniversalSearch()">OK</button>
    </div>
  </div>

</div>
<b-modal title="Table Settings" id="tableSettings" size="lg" ref="tblSettings" ok-only>
  <h4 id="columns_shown">Columns Shown</h4>
  <div class="row mt-2" v-for="wcol in wdata[wtID].filter(p=>p.ishidden===false)">
    <div class="col-1">
      <button class="btn-transparent" v-show="wcol.canhide!==false" @click="hideColumn(wcol.id)"><font-awesome-icon icon="times" aria-label="Hide this column"></font-awesome-icon></button>
    </div>
    <div class="col-11">
      <b>{{ getTranslatedText(wcol.name) }}</b>
    </div>
  </div>
  <div v-show="wdata[wtID].filter(p=>p.ishidden!==false).length>0">
    <div class="row mt-4">
      <div class="col-12">
        <h4 id="columns_not_shown">Columns Not Shown</h4>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-8">
        <select v-model="columntoadd" class="fullWidth" id="ddlColumnAdd">
          <option value=null>{{ getTranslatedText('--- Select ---') }}</option>
          <option v-for="wcol in wdata[wtID].filter(p=>p.ishidden!==false)" v-bind:value="wcol.id">{{ getTranslatedText(wcol.name) }}</option>
        </select>
      </div>
      <div class="col-4">
        <button id="add_column" class="btn btn-secondary" @click="unhidecolumn()">Add</button>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <font-awesome-icon icon="arrows-alt"></font-awesome-icon>&nbsp;&nbsp;<span id="columns_reordered">Columns can be re-ordered by drag and dropping them in the table itself</span>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-12">
      <button id="restore_default" class="btn btn-secondary btn-short" @click="doDefault">Restore Defaults</button>
    </div>
  </div>
</b-modal>
  </div>
</template>

<style scoped>
  .burger {
    width: 100%;
    margin: 0;
    height: 35px;
    padding: 0px 0px 0px 25px;
  }

  .fakeHeight {
    font-size: 19px;
    color: #2a6693;
  }

  .isOdd {
    background-color: #EEE;
  }

  .popoutFilter input {
    height: 25px;
  }

  .toolbuttons {
    padding-left: 0px !important;
  }

    .toolbuttons button {
      padding: 2px !important;
    }

  .wtTopBorder {
    padding-top: 10px;
    border-top: 1px solid #666;
  }

  .wtHeader {
    margin-bottom: 15px;
  }

  .wtColumnName button {
    font-weight: 600;
  }

  .wtColumnHeader {
    border: 1px solid #fff;
    color: #fff;
    background-color: #2a6693;
    padding: 10px;
    position: relative;
  }

  .wtColumn {
    padding: 10px;
  }
</style>

<script language="javascript">
  import "core-js/stable";
  import "regenerator-runtime/runtime";
  import { utilities } from '../mixins/index.js'


  export default {
    name: 'WonderTable',
    props: [
      "wtID",
      "tcapiData",
      "methods",
      "noRecords",
      "ids",
      "hasExportExcel",
      "hasExportPDF",
      "title",
      "burgerMenu",
      "defaultDirection",
      "isAdmin",
      "paginationCount",
      "totalRecords",
      "noFreeFilter"
    ],
    mixins: ["utilities"],
    data() {
      return {
        burgerselect: null,
        columntoadd: null,
        cols: null,
        index: 1,
        rows: null,
        colsort: null,
        filtercols: {},
        pageselected: 1,
        recordcount: 0,
        universalSearchVisible: false,
        universalSearchText: null,
        wdata: null
      }
    },
    computed: {
      endPageSpan: function () {
        var t = ((this.pageselected - 1) * 500) + 500;
        if (t > this.totalRecords) {
          t = this.totalRecords;
        }
        return t;
      },
      pageCount: function () {
        return typeof (this.paginationCount) === "undefined" ? null : this.paginationCount;
      },
      startPageSpan: function () {
        return ((this.pageselected - 1) * 500) + 1;
      }
    },
  methods: {
      getTranslatedText(text) {
        return Window.getTranslatedText ? Window.getTranslatedText(text) : text;
      },
      cancelUniversalSearch() {
        this.universalSearchVisible = false;
      },
      columnTransform(row, template, id, ids) {
        if (template === "{USERNAME}") {
          return this.buildSimUser(row.ClientID, row.Username, row.EmailAddress, row.FirstName, row.LastName, true, true);
        }
        else  if (template === "{EmailAddress}") {
          return this.buildSimUserEmail(row.ClientID, row.Username, row.EmailAddress, row.FirstName, row.LastName, true, true);
        }
        else if (template === "{DATE}") {
          return this.buildDateTime(row[id], false);
        }
        else if (template === "{DATETIME}") {

          //if (sessionStorage.getItem("userLanguageID"))
          //{
          //  if (sessionStorage.getItem("userLanguageID")!="00000000-0000-0000-0000-000000000000")
          //  {
          //    return row[id];
          //  }
          //}

          //return this.buildDateTime(row[id], true);

          return row[id];
        }
        else if (template === "{CURRENCY}") {
          return "$" + row[id];
        }
        else if (template === "{MEMBERSTATUS}") {
          return this.buildMemberStatus(row.LicensePoolName, row.VerificationID, row.LicensePoolID, row.ClientID, this.isAdmin);
        }
        else if (template.indexOf("{METHOD:") > -1) {
          var obj = {};
          for (var id of ids) {
            obj[id] = row[id];
          }
          return obj;
        }
      },
      doBurgerChange() {
        if (this.burgerselect !== null) {
          var method = this.methods[this.burgerselect];
          this.burgerselect = null;
          this.doMethod(method.method, null, method.ref);
        }
      },
      doBurgerClick(m) {
        var method = this.methods[m];
        this.doMethod(method.method, null, method.ref);
      },
      doDefault() {
        this.$bvModal.msgBoxConfirm('This feature will reset the table settings to the default. Are you sure you wish to do that?', {
          id: 'reset_table_setting',
          title: 'Confirm Reset',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {

            this.setWonderTableDefault(this.wtID);
            this.wdata = this.getWonderProfile(this.wtID);
            this.renderTable();
            setTimeout("Window.loadLanguageContent()", 500);
          }
        });
        setTimeout("Window.loadLanguageContent()", 500);
      },
      doExcelExport() {
        debugger;
       
        var qt = [];

        // Add column headers as the first row
        qt.push(this.cols.map(col => this.getTranslatedText(col.id)));

        for (var row of this.rows) {
          var xArr = [];

          for (var col of this.cols) {
            try {
              let val = row[col.id] ? String(row[col.id]) : ""; // Ensure it's a string
              val = val.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, "");

              if (!val.includes("object")) {
                xArr.push(val);
              }
            } catch (e) {
              xArr.push(""); // Default empty value in case of error
            }
          }

          qt.push(xArr);
        }

        console.log(qt); // Output the processed data


        const LanguageName = sessionStorage.getItem("userLanguage");
        var postData = {
          SessionID: JSON.parse(localStorage.getItem("udata")).SessionID,
          TabularData: JSON.stringify(qt),
          LanguageName:LanguageName
        }

        let nm = this.title.replace(/\s/g, "_").toLowerCase();
        const translations = {
          pool_members: "miembros_del grupo",
          group_members: "miembros_del grupo",
          privileged_members: "miembros_privilegiados",
          transcript_results: "resultados de la transcripción"
        };

        const LanguageID = sessionStorage.getItem("userLanguageID");
        if (LanguageID !== "00000000-0000-0000-0000-000000000000" && translations[nm]) {
          nm = translations[nm];
        }


        var req = new XMLHttpRequest();
        req.open("POST", this.$hostname + '/Streamable.svc/ExportToExcel', true);
        req.responseType = "blob";
        req.setRequestHeader("Content-type", "application/json");
        req.onload = function (event) {
          var blob = req.response;
          var fileName = nm + ".xlsx"
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
        };

        req.send(JSON.stringify(postData));
      },
      doMessageExport() {

      },
      doFilter(cid) {
        var ft = this.cols.filter(p => p.id === cid)[0].filtertext;
        if (ft.length > 0) {
          this.filtercols[cid] = { filtertext: ft };
        }
        else {
          this.filtercols[cid] = null;
        }
        this.renderTable();
      },
      doMethod(tmeth, tparam, tref) {
        tmeth(tparam, tref);
      },
      doNext() {
        this.pageselected++;
        this.doPageSelection();
      },
      doPageSelection() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;

        this.$parent.doWTPage(this.pageselected, false, this.universalSearchText);
      },
      doPDFExport() {
        var qt = [];
        for (var row of this.rows) {
          var xArr = [];
          for (var col of this.cols) {
            try {
              xArr.push(row[col.id].replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, ""));
            }
            catch (e) {
              try {
                xArr.push(xArr.push(new String(row[col.id])));
              }
              catch (e) {
                xArr.push("");
              }
            }
          }
          qt.push(xArr);
        }

        var postData = {
          SessionID: JSON.parse(localStorage.getItem("udata")).SessionID,
          TabularData: JSON.stringify(qt)
        }

        var nm = this.title.replace(" ", "_");

        var req = new XMLHttpRequest();
        req.open("POST", this.$hostname + '/Streamable.svc/ExportToPDF', true);
        req.responseType = "blob";
        req.setRequestHeader("Content-type", "application/json");
        req.onload = function (event) {
          var blob = req.response;
          var fileName = nm + ".pdf"
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
        };

        req.send(JSON.stringify(postData));
      },
      doPrev() {
        this.pageselected--;
        this.doPageSelection();
      },
      doShowAll() {
        this.$parent.showAll(this.universalSearchText);
      },
      doSort(cid) {
        if (this.colsort.id === cid) {
          this.colsort.direction = this.colsort.direction === 0 ? 1 : 0;
          this.renderTable();
        }
        else {
          var coldata = this.wdata[this.wtID].filter(p => p.id === cid)[0];
          if (coldata.issortable) {
            this.colsort = { id: cid, data: coldata.data, direction: 0 };
            this.renderTable();
          }
        }
      },
      doTableSettings() {
        this.$refs.tblSettings.show();
        setTimeout("Window.loadLanguageContent()", 500);
      },
      doUniversalSearch() {

        this.universalSearchVisible = false;
        this.pageselected = 1;
        this.$parent.doCount(this.universalSearchText).then(r => {
          if (r) {
            this.$parent.doWTPage(0, false, this.universalSearchText);
          }
        })


      },
      hideColumn(colid) {
        if (this.wdata[this.wtID].filter(p => p.ishidden === true).length === this.wdata[this.wtID].length - 1) {
          this.popDialog(1, "You cannot hide all columns in the table");
          return;
        }

        for (var wcol of this.wdata[this.wtID].filter(p => p.id == colid)) {
          wcol.ishidden = true;
        }

        this.saveWonderProfile(this.wdata);
        this.renderTable();
        setTimeout("Window.loadLanguageContent()", 500);
      },
      openFilter(cid) {
        this.cols.filter(p => p.id === cid)[0].isopen = !this.cols.filter(p => p.id === cid)[0].isopen;
      },
      renderTable(forceTCAPIData) {
        this.rows = [];
        this.cols = [];
        var tcapiResults = this.tcapiData;

        if (typeof (forceTCAPIData) !== "undefined" && forceTCAPIData !== null) {
          tcapiResults = forceTCAPIData;
        }

        // Build columns
        for (var wcol of this.wdata[this.wtID]) {

          if (!wcol.ishidden) {

            var icon = null;
            var method = null;
            var ref = null;
            if (wcol.data.indexOf("{METHOD") > -1) {
              var ted = wcol.data.replace("{METHOD:", "").replace("}", "");
              icon = wcol.icon;
              method = this.methods[ted].method;
              ref = this.methods[ted].ref;
            }

            if (this.colsort === null && wcol.issortable) {
              this.colsort = { id: wcol.id, data: wcol.data, direction: this.defaultDirection === null ? 0 : this.defaultDirection };
            }

            var io = false;
            var ft = "";

            if (typeof (this.filtercols[wcol.id]) !== "undefined") {
              io = true;
              if (this.filtercols[wcol.id] !== null) {
                ft = this.filtercols[wcol.id].filtertext;
              }
            }

            this.cols.push(
              {
              name: this.getTranslatedText(wcol.name), id: wcol.id, data: wcol.data, iscalculated: wcol.iscalculated, icon: icon, method: method, ref: ref, position: wcol.position, islast: false,
                wtid: this.wtID, isfilterable: wcol.isfilterable, isopen: io, filtertext: ft, canMove: true, islink: wcol.islink
              }
            );

          }
        }

        if (this.cols.length > 0) {
          this.cols[this.cols.length - 1].islast = true;
        }

        if (this.cols.length > 0) {
          var isOdd = false;

          // Sort
          for (var item of tcapiResults) {
            if (this.colsort.data === "{USERNAME}") {
              item.s_sortable = this.buildSimUser(item.ClientID, item.Username, item.EmailAddress, item.FirstName, item.LastName, false, false).toLowerCase();
            }
            else if (this.colsort.data === "{EmailAddress}") {
              item.s_sortable = this.buildSimUserEmail(item.ClientID, item.Username, item.EmailAddress, item.FirstName, item.LastName, false, false).toLowerCase();
            }
            else if (this.colsort.data === "{MEMBERSTATUS}") {
              item.s_sortable = this.buildMemberStatus(item.LicensePoolName, item.VerificationID, item.LicensePoolID, item.ClientID, this.isAdmin).toLowerCase();
            }
            else {
              try {
                item.s_sortable = item[this.colsort.id].toLowerCase();
              }
              catch (e) {
                item.s_sortable = item[this.colsort.id]
              }
            }
          }

          // Build rows
          for (var wrow of tcapiResults.sort(this.tcapiSortMethod)) {
            var row = {};
            row.isOdd = isOdd;
            var pushrow = true;

            for (var wcol of this.cols) {

              if (wcol.data.indexOf("{") === -1) {
                row[wcol.id] = wrow[wcol.id];
              }
              else {
                if (wcol.islink) {
                  row['oid'] = wrow[wcol.id];
                }
                row[wcol.id] = this.columnTransform(wrow, wcol.data, wcol.id, this.ids);

              }

              if (wcol.filtertext.length > 0) {
                if (wcol.islink) {
                  if (row['oid'].replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, "").toLowerCase().indexOf(wcol.filtertext.toLowerCase()) === -1) {
                    pushrow = false;
                  }
                }
                else {
                  if (row[wcol.id].replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, "").toLowerCase().indexOf(wcol.filtertext.toLowerCase()) === -1) {
                    pushrow = false;
                  }
                }
              }
            }

            if (pushrow) {
              this.rows.push(row);
              isOdd = !isOdd;
            }
          }
        }

        this.recordcount = this.rows.length;

      },
      showUniversalSearch() {
        this.universalSearchVisible = true;
      },
      tcapiSortMethod(a, b) {
        let comparison = 0;

        if (a["s_sortable"] > b["s_sortable"]) {
          comparison = this.colsort.direction === 0 ? 1 : -1;
        } else if (a["s_sortable"] < b["s_sortable"]) {
          comparison = this.colsort.direction === 0 ? -1 : 1;
        }
        return comparison;
      },
      unhidecolumn() {
        if (this.columntoadd === null) {
          return;
        }

        for (var wcol of this.wdata[this.wtID].filter(p => p.id === this.columntoadd)) {
          wcol.ishidden = false;
        }

        this.saveWonderProfile(this.wdata);
        this.renderTable();
        setTimeout("Window.loadLanguageContent()", 500);
      }

    },
    mounted() {

      this.wdata = this.getWonderProfile(this.wtID);
      this.renderTable();
    }

  }
</script>
